
/* eslint-disable vue/one-component-per-file */

import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import {
  RoundedIcon,
  Heading,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { OrderType, OrderTypesPrimary } from '../Order';
import { ETradeOrderStatus } from '@/modules/common/services/graphql/server/server.sdk';

@Component({
  components: {
    RoundedIcon,
    Heading,
    ButtonPrimary
  }
})
export default class StatusInstrument extends Vue {
  @Prop({ type: String, required: true })
  readonly title!: string;

  @Prop({ type: String, required: true })
  readonly label!: string;

  @Prop({ type: String, required: true })
  readonly description!: string;

  @Prop({ type: String })
  readonly iconName!: string;

  @Prop({ type: String })
  readonly iconBackgroundColor!: string;

  @Prop({ type: String })
  readonly iconTextColor!: string;

  readonly NebraskaColors = NebraskaColors;

  @Emit('refresh')
  public refreshInstrument() {}
}

export const StatusInstrumentWithoutFeedback = Vue.component(
  'StatusInstrumentWithoutFeedback',
  {
    props: {
      orderType: {
        type: Number,
        required: true
      }
    },
    render(createElement) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      const instrumentHeaderType =
        this.$props.orderType === OrderType.Buy
          ? OrderTypesPrimary.Buy
          : OrderTypesPrimary.Sell;

      return createElement(StatusInstrument, {
        props: {
          title: `Confirmação de ${instrumentHeaderType}`,
          label: 'Sua ordem foi recebida!',
          description: 'Tudo certo! Sua ordem está sendo processada.',
          iconTextColor: NebraskaColors.themeOverPrimary,
          iconBackgroundColor: NebraskaColors.statusPositiveBackground,
          iconName: 'ic_check_simple'
        },
        on: {
          refresh() {
            self.$emit('refresh');
          }
        }
      });
    }
  }
);

export const StatusInstrumentWithFeedback = Vue.component(
  'StatusInstrumentWithFeedback',
  {
    props: {
      statusMessage: {
        type: Object,
        required: true
      },
      orderStatus: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        feedbackIconProps: {
          iconTextColor: '',
          iconBackgroundColor: '',
          iconName: ''
        }
      };
    },
    created() {
      switch (this.$props.orderStatus) {
        case ETradeOrderStatus.Filled:
          this.$data.feedbackIconProps = {
            iconTextColor: NebraskaColors.themeOverPrimary,
            iconBackgroundColor: NebraskaColors.statusPositive,
            iconName: 'ic_check_simple'
          };

          break;
        case ETradeOrderStatus.Rejected:
          this.$data.feedbackIconProps = {
            iconTextColor: NebraskaColors.themeOverPrimary,
            iconBackgroundColor: NebraskaColors.statusNegativeBackground,
            iconName: 'ic_attention'
          };

          break;
        default:
          this.$data.feedbackIconProps = {
            iconTextColor: NebraskaColors.themeOverPrimary,
            iconBackgroundColor: NebraskaColors.statusAlertBackground,
            iconName: 'ic_progress_clock'
          };

          break;
      }
    },
    render(createElement) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;

      return createElement(StatusInstrument, {
        props: {
          title: self.$props.statusMessage.title,
          label: self.$props.statusMessage.label,
          description: self.$props.statusMessage.description,
          iconTextColor: self.$data.feedbackIconProps.iconTextColor,
          iconBackgroundColor: self.$data.feedbackIconProps.iconBackgroundColor,
          iconName: self.$data.feedbackIconProps.iconName
        },
        on: {
          refresh() {
            self.$emit('refresh');
          }
        }
      });
    }
  }
);
